import React, { useRef, useState } from "react";
import { Trash2 } from "lucide-react";

const LIMIT = 90;

export const SwipeRow = ({ onDismiss, onTap, children, testId }) => {
  const [dx, setDx] = useState(0);
  const [gone, setGone] = useState(false);
  const start = useRef(null);
  const moved = useRef(false);

  const down = (e) => { const p = e.touches ? e.touches[0] : e; start.current = { x: p.clientX, y: p.clientY }; moved.current = false; };
  const move = (e) => {
    if (!start.current) return;
    const p = e.touches ? e.touches[0] : e;
    const ddx = p.clientX - start.current.x, ddy = p.clientY - start.current.y;
    if (Math.abs(ddy) > Math.abs(ddx) && !moved.current) { start.current = null; setDx(0); return; }
    if (Math.abs(ddx) > 6) moved.current = true;
    if (moved.current) setDx(ddx);
  };
  const up = () => {
    if (!start.current) return;
    start.current = null;
    if (Math.abs(dx) >= LIMIT) { setGone(true); setDx(dx > 0 ? 500 : -500); setTimeout(() => onDismiss(), 180); }
    else { setDx(0); if (!moved.current && onTap) onTap(); }
  };

  return (
    <div className={`relative overflow-hidden rounded-2xl transition-[max-height,margin] duration-200 ${gone ? "max-h-0 !mt-0" : "max-h-60"}`} data-testid={testId}>
      <div className={`absolute inset-0 flex items-center ${dx < 0 ? "justify-end pr-5" : "justify-start pl-5"} ${Math.abs(dx) >= LIMIT ? "bg-red-500" : "bg-red-200"} text-white rounded-2xl`}>
        <Trash2 className="w-5 h-5" />
      </div>
      <div className="relative touch-pan-y select-none" style={{ transform: `translateX(${dx}px)`, transition: start.current ? "none" : "transform 180ms ease-out" }}
        onTouchStart={down} onTouchMove={move} onTouchEnd={up} onTouchCancel={up} onMouseDown={down} onMouseMove={move} onMouseUp={up} onMouseLeave={() => start.current && up()}>
        {children}
      </div>
    </div>
  );
};
